import useOutsideClick from "../../hooks/useOutsideClick";

const { useState, useEffect, cloneElement } = require("react");
const { default: PopUpModal } = require("./PopUpModal");

const CustomModal  = ({ selector, content }) => {
	const [show, setShow] = useState(false);
	const contentWithProps = cloneElement(content, { setShow });

	const [box] = useOutsideClick({
		state: true,
		callBack: () => {
			setShow(false);
		},
	});


	return (
    <>
      <div onClick={() => setShow(true)}>{selector}</div>
      {show && (
        <PopUpModal>
          <div className="fixed inset-0 flex items-center justify-center overflow-y-auto modal z-99999">
            <div className="fixed inset-0 h-full w-full bg-gray-400/50 backdrop-blur-[32px]"></div>
            <div
              className="relative w-full rounded-3xl bg-white dark:bg-gray-900 max-w-[584px] p-5 lg:p-10"
              ref={box}
            >
              {contentWithProps}
            </div>
          </div>
        </PopUpModal>
      )}
    </>
  );
};

export default CustomModal;
